import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComicsGrid() {
  const hotComics = comics.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-12 gap-4">
          <div>
            <span className="inline-block text-xs font-label text-foreground-500 uppercase tracking-wider mb-3">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              本周热门
              <br />
              编辑精选
            </h2>
          </div>
          <Link
            to="/category/romance"
            className="text-sm font-label text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group block"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫漫画网热门推荐`}
                  className="w-full h-full object-cover transition-transform duration-400 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-background-50/90 backdrop-blur-sm text-xs font-label text-foreground-700">
                  {comic.status}
                </div>
                {comic.rating >= 9.5 && (
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500/90 backdrop-blur-sm text-xs font-label text-background-50">
                    高分推荐
                  </div>
                )}
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-1 line-clamp-1 group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-1">
                {comic.latestChapter}
              </p>
              <div className="flex items-center gap-2 mt-1.5">
                <div className="flex items-center gap-0.5">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-xs text-accent-500"></i>
                  </div>
                  <span className="text-xs font-label text-foreground-600">{comic.rating}</span>
                </div>
                <span className="text-xs text-foreground-400">{comic.views}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}